import React from "react";
import { Typography } from "@mui/material";
import { formatPhone } from "utils/phone";
import styles from "./phone-number.module.css";

const PhoneNumber: React.FC<{
  label?: string;
  ext?: string | null;
  enabled?: boolean | null;
  number: string | null;
  missing: React.ReactNode;
}> = ({ label, number, missing, ext, enabled }) => {
  if (label && number) {
    return <Typography variant="body1">
      {label}: <a href={`tel:${number}`}>{formatPhone(number)} {ext && `ext. ${ext}`}</a>
      {enabled === false && "- Opted out"}
    </Typography>;
  }

  if (number) return <a href={`tel:${number}`}>{formatPhone(number)}</a>;

  if (missing) return <span className={styles.missing}>{missing}</span>;

  return null;
};

export default PhoneNumber;
